import { MatButtonModule } from '@angular/material/button'
import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { Router } from '@angular/router'

@Component({
	standalone: true,
	imports: [CommonModule, MatIconModule, MatButtonModule],
	selector: 'feature-porto-bank-reservation-disabled',
	template: `
		<section
			style="padding: 16px; display: flex; flex-direction: column; align-items: flex-start; gap: 16px;"
		>
			<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
				<mat-icon svgIcon="porto-bank-icons:alert"></mat-icon>

				<mat-icon
					svgIcon="porto-bank-icons:close-circle"
					(click)="dialogRef.close()"
					style="cursor: pointer;"
				></mat-icon>
			</div>

			<h1 style="font-size: 22px; font-weight: 600; color: #000;">Reserva não habilitada.</h1>

			<p style=" padding-right: 20px; color: var(--content-txt-black);">
				Esse restaurante ainda não realiza reservas.
			</p>

			<div style="display: flex; gap: 8px; align-self: flex-end; margin-top: 16px;">
				<button
					mat-button
					(click)="dialogRef.close()"
					style="background-color: var(--content-primary); color: white; font-weight: 600; font-size: 15px; max-width: 55px; height: 30px"
				>
					Fechar
				</button>
			</div>
		</section>
	`,
})
export class ReservationDisabledComponent {
	private router = inject(Router)
	public dialogRef = inject(MatDialogRef<ReservationDisabledComponent>)

	reserve() {
		this.router.navigate(['reserva'])
	}
}
